<template>
    <div id="text_require" v-if="showtextEditor" @click.self="maskClickEvn">
        <div class="text_require">
            <div class="text_require1">
                <div>{{ titleText }}</div>
                <img @click="closePopup" class="cursor_1" src="../assets/image/icon_close.png" alt="">
            </div>
            <div class="text_require1 text_require4">{{ requireTitle }}(非必填)</div>
            <div class="text_require2">
                <el-input type="textarea" :maxlength="5000" show-word-limit :autosize="{ minRows: 8, maxRows: 8 }"
                    :placeholder="placeholder" v-model="requireText">
                </el-input>
            </div>
            <div v-if="showIM">
                <div class="text_require1 text_require4">正文仿写模版(非必填)</div>
                <div class="text_require2">
                    <el-input type="textarea" :maxlength="5000" show-word-limit :autosize="{ minRows: 8, maxRows: 8 }"
                        :placeholder="placeholder" v-model="fx">
                    </el-input>
                </div>
            </div>

            <div class="text_require3">
                <div class="text_require3_1 cursor_1" @click="getRequire">确认</div>
            </div>
        </div>
    </div>
</template>
<script>
import { EventBus } from '@/utils/eventBus'
import api from '@/api/api'
export default {
    props: {
        maskClick: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: '在这里填写你希望出现的情节、人设或风格，AI会根据这些信息生成更贴合你想法的正文内容。(仅作用于当前章节的正文)'
        },
        showIM: {
            type: Boolean,
            default: false
        },
        requireTitle:{
            type:String,
            default:'作品要求'
        },
    },
    data() {
        return {
            // placeholder: '',
            requireText: '',
            showtextEditor: false,
            titleText: '换一换',
            type: '',//小说开头
            fx: ''//仿写内容
        }
    },
    methods: {
        openPrompt(type, title) {
            this.showtextEditor = true
            this.type = type
            this.titleText = title
            //获取仿写内容
            if (this.showIM) {
                this.getFxContent({ key: 'refer' }, (data) => {
                    this.fx = data && data.content
                })
            }
        },
        open(title,requireText) {
            this.showtextEditor = true
            this.titleText = title
            this.requireText = requireText
        },
        // 获取正文
        // getFxContent() {
        //     const editItem = JSON.parse(sessionStorage.getItem('editItem'))
        //     api.getNovelContent(editItem.textId).then((res) => {
        //         if (res.code == 200) {
        //             this.requireText = res.data.requirement
        //         }
        //     })
        // },
        //蒙层点击事件
        maskClickEvn() {
            if (this.maskClick) return
            this.closePopup();
        },
        closePopup() {
            this.showtextEditor = false
        },
        getRequire() {
            //当开启仿写状态的时候才会保存仿写内容
            if (this.showIM) {
                this.saveFxContent({ key: 'refer', content: this.fx, name: '参考格式' })
            }
            EventBus.$emit('getRequire', this.requireText, this.type, this.fx)
            this.closePopup()
        }
    }
}
</script>

<style>
#text_require {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.text_require {
    background-color: #FFFFFF;
    border-radius: 5px;
}

.text_require1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px 40px;
    width: 600px;
    font-weight: bold;
    font-size: 19px;
    color: #111111;
}

.text_require img {
    width: 21px;
    height: 21px;
}

.text_require2 {
    padding: 25px 40px;
}

.text_require3 {
    display: flex;
    justify-content: end;
    padding: 10px 40px;
}

.text_require3_1 {
    font-size: 17px;
    color: #FFFFFF;
    width: 125px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    background: var(--tech-primary);
    border-radius: 8px;
}

.text_require4 {
    padding: 0 40px;
}
</style>